var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('nav-bar'),_c('div',{staticClass:"main-container"},[_c('side-bar',{attrs:{"menu-items":_vm.menuItems}}),_c('main-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }